module.exports = __webpack_public_path__ + "static/media/logo.bab55d1d.png";